<template>
  <div>
    <!-- <div class="py-2">
      <h3 class="section-title">Address</h3>
      <p class="section-subtitle">Where is your business based?</p>
    </div> -->

    <div class="details-stack">
      <div class="mb-2">
        <AppTextField
          :model-value="line_1"
          label="Address Line 1"
          label-icon="mdi-map-marker-outline"
          placeholder="123 Main St"
          :error-messages="errors.line_1 ? [errors.line_1] : []"
          @update:modelValue="$emit('update:line_1', $event)"
        />
      </div>

      <div class="mb-2">
        <AppTextField
          :model-value="line_2"
          label="Address Line 2"
          label-icon="mdi-home-outline"
          placeholder="Suite, Apt, etc."
          hide-details
          @update:modelValue="$emit('update:line_2', $event)"
        />
      </div>

      <div class="mb-2">
        <AppTextField
          :model-value="city"
          label="City"
          label-icon="mdi-city-variant-outline"
          placeholder="New York"
          :error-messages="errors.city ? [errors.city] : []"
          @update:modelValue="$emit('update:city', $event)"
        />
      </div>

      <v-row>
        <v-col cols="6">
          <div class="mb-2">
            <AppTextField
              :model-value="state"
              label="State"
              label-icon="mdi-map-outline"
              placeholder="NY"
              :error-messages="errors.state ? [errors.state] : []"
              @update:modelValue="$emit('update:state', $event)"
            />
          </div>
        </v-col>
        <v-col cols="6">
          <div class="mb-2">
            <AppTextField
              :model-value="zip"
              label="ZIP"
              label-icon="mdi-mailbox-outline"
              placeholder="10001"
              :error-messages="errors.zip ? [errors.zip] : []"
              @update:modelValue="$emit('update:zip', $event)"
            />
          </div>
        </v-col>
      </v-row>

    </div>
  </div>
</template>

<script setup lang="ts">
import AppTextField from "@/shared/components/ui/AppTextField.vue";

withDefaults(
  defineProps<{
    line_1: string;
    line_2: string;
    city: string;
    state: string;
    zip: string;
    lat: string | null;
    lng: string | null;
    country_code: string | null;
    country: string | null;
    errors: {
      line_1?: string;
      city?: string;
      state?: string;
      zip?: string;
    };
  }>(),
  {
    line_1: "",
    line_2: "",
    city: "",
    state: "",
    zip: "",
    lat: null,
    lng: null,
    country_code: null,
    country: null,
    errors: () => ({}),
  },
);

defineEmits([
  "update:line_1",
  "update:line_2",
  "update:city",
  "update:state",
  "update:zip",
  "update:lat",
  "update:lng",
  "update:country_code",
  "update:country",
]);
</script>

<style scoped>
.section-title {
  text-transform: capitalize;
}

.section-subtitle {
  margin: 0 0 14px;
  color: #73829a;
  font-size: 14px;
}

.details-stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
</style>
